import tools from '../../../../assets/javascript/tools.js'
export default {
	columns: {
		reportDate: {
			label: '日期',
			visible: true,
			width: 'auto',
			formatDay: true,
			align: 'left',
		},
		staffName: {
			label: '店员姓名',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		guaranteeFlagCn: {
			label: '入职补助',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		staffNumber: {
			label: '在店人数',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		attendanceFlagCn: {
			label: '出勤',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		amount: {
			label: '补贴金额',
			visible: true,
			width: 'auto',
			align: 'left',
		},
  },
  otherColumns: {
    reportDate: {
			label: '日期',
			visible: true,
			width: 'auto',
			formatDay: true,
			align: 'left',
		},
		staffName: {
			label: '店员姓名',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		staffNumber: {
			label: '在店人数',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		attendanceFlagCn: {
			label: '出勤',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		amount: {
			label: '补贴金额',
			visible: true,
			width: 'auto',
			align: 'left',
		},
  }
}
